import React from 'react';
import {
    TextInput,
    SelectInput,
    NumberInput,
    BooleanInput,
    FormDataConsumer,
    PasswordInput,
    BooleanField,
    DateInput,
    required,
    NullableBooleanInput,
    SimpleForm,
} from 'react-admin';
import { Box, Grid, Typography } from '@mui/material';



const RequestAccessTAW = (props) => (
    <SimpleForm>
            <Grid container width="100%" spacing={2}>
                <Grid item xs={8}>
                    
                    <Typography variant="h6" gutterBottom>
                        Organisation Details
                    </Typography>

                    <TextInput source="organisation_name" label="Organisation name" validate={required()} fullWidth />
                    <SelectInput
                        source="industry_type"
                        label="Industry type"
                        choices={[
                            { id: 'option1', name: 'Option 1' },
                            { id: 'option2', name: 'Option 2' },
                        ]}
                        validate={required()}
                        fullWidth
                    />

                    <NumberInput source="employees_count" label="Amount of employees in organisation" validate={required()} fullWidth />

                    <Box display="flex">
                        <Box flex={3} mr="1">
                            <TextInput source="address.building_name_number" label="Building name/number" validate={required()} multiline />
                        </Box>

                        <Box flex={3} mr="1">
                            <TextInput source="address.street" label="Street" validate={required()} multiline />
                        </Box>

                        <Box flex={3} mr="1">
                            <TextInput source="address.post_town_city" label="Post town/city" validate={required()} multiline />
                        </Box>

                        <Box flex={3} mr="1">
                            <TextInput source="address.county_region" label="County/Region" validate={required()} multiline />
                        </Box>

                        <Box flex={3} mr="1">
                            <TextInput source="address.postcode" label="Postcode" validate={required()} multiline />
                        </Box>

                    </Box>

                    <TextInput source="phone_number" label="Organisation phone number" validate={required()} fullWidth />
                    <BooleanInput source="is_whole_organisation" label="Are you registering as a whole organisation or as a department(s) within a larger organisation?" />
                    <BooleanInput source="is_single_site" label="Is the organisation/department based on one site only?" />

                            
                    <Box mt="1em" />
                    <Typography variant="h6" gutterBottom>
                        Key Contact details
                    </Typography>

                    <Box display="flex">
                        <Box flex={2} mr="0.5em">
                            <TextInput source="key_contact.first_name" label="First name" validate={required()} fullWidth />
                        </Box>
                        <Box flex={2} mr="0.5em">
                            <TextInput source="key_contact.last_name" label="Last name" validate={required()} fullWidth />
                        </Box>
                    </Box>
                    <Box mt="1em" />

                                        
                    <TextInput source="key_contact.job_title" label="Job title" validate={required()} fullWidth />
                    <TextInput source="key_contact.phone_number" label="Phone number" validate={required()} fullWidth />
                    <TextInput source="key_contact.email" label="Email address" validate={required()}fullWidth />

                    <Box display="flex">
                        <Box flex={1} mr="0.5em">
                            <PasswordInput source="password" fullWidth />
                        </Box>
                        <Box flex={1} ml="0.5em">
                            <PasswordInput
                                source="confirm_password"
                                fullWidth
                            />
                        </Box>
                    </Box>
                </Grid>


                <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>
                        Director details
                    </Typography>
                    <TextInput source="director_name" label="Director name" validate={required()} fullWidth />
                    <TextInput source="director_job_title" label="Director job title" validate={required()} fullWidth />
                    <TextInput source="director_email" label="Director email" validate={required()} fullWidth />


                    <Box mt="1em" />
                    <Typography variant="h6" gutterBottom>
                        Additional questions
                    </Typography>
                        <BooleanInput source="committed_to_improving_health" label="Do you feel your organisation is committed to improving the health and wellbeing of its employees?" fullWidth />
                        <BooleanInput source="has_wellbeing_plan_policy" label="Do you have health and wellbeing plan or policy on place?" />
                        <BooleanInput source="has_wellbeing_lead" label="Do you have a health and wellbeing lead in the organisation?" />
                        <BooleanInput source="offers_health_training" label="Do you currently offer your employees health and welbeing training or other support in the following areas?" />
                    <Box mt="1em" />


                    <Box mt="1em" />
                    <Typography variant="h6" gutterBottom>
                        Where did you hear about Thrive at Work?
                    </Typography>
                        <SelectInput
                            source="hearing_source"
                            label="Where did you hear about Thrive at Work?"
                            choices={[
                                { id: 'option1', name: 'Option 1' },
                                { id: 'option2', name: 'Option 2' },
                            ]}
                            fullWidth
                        />
                    <Box mt="1em" />


                    <Box mt="1em" />
                    <Typography variant="h6" gutterBottom>
                        Why did you sign up to the Thrive at Work?
                    </Typography>
                    <TextInput source="sign_up_reason" label="Why did you sign up to the Thrive at Work?" validate={required()} fullWidth multiline />
                    <Box mt="1em" />


                    <Box mt="1em" />
                    <Typography variant="h6" gutterBottom>
                        Privacy Policy
                    </Typography>
                        <BooleanInput source="agree_wmca_privacy_policy" label="I agree to the WMCA (West Midlands Combined Authority) Privacy Policy" />
                        <BooleanInput source="receive_emails" label="I agree to receive emails relating to the Thrive at Work programme" />
                    <Box mt="1em" />
        
                </Grid>

            </Grid>
        </SimpleForm>
);


export default RequestAccessTAW;

